import type { ElasticVehicle } from '../@types/ElasticVehicle';
import type Item from '../@types/item';

export const forItem = (item: ElasticVehicle | Item, format: string) => {
  try {
    return item.featuredImage?.files[0].formats.filter((f) => f.format === format).pop()?.url;
  } catch (_e) {
    return '/images/placeholders/placeholder_product_card.jpg';
  }
};

export const forItemWebp = (item: ElasticVehicle | Item, format: string) => {
  try {
    return item.featuredImage?.files[0].formats.filter((f) => f.format === format).pop()?.webp;
  } catch (_e) {
    return undefined;
  }
};

export const resize = (image: string, format: string) => {
  if (!image || !format) {
    return null;
  }

  return image.replace(/\/\dx\d/, format);
};
